import styled from "styled-components";

/**
 * Wrapper da Linha
 * Configura o layout geral da linha com ajustes de padding e bordas.
 */
export const RowWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(2)};

  &:first-child > div {
    padding-top: 0;
  }

  &:last-child > div {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

/**
 * Wrapper do Seletor
 * Organiza os controles e o rótulo, garantindo espaçamento consistente.
 */
export const SelectorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => `${theme.spacing(1)} 0`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.mediumGray};
`;

/**
 * Wrapper de Descrição
 * Alinha o ícone e o título com espaçamento ajustável.
 */
export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0 ${({ theme }) => theme.spacing(1)};
  flex-direction: column;
`;
export const DescriptionWrapperRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0 ${({ theme }) => theme.spacing(1)};
`;

export const DescriptionButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0 ${({ theme }) => theme.spacing(1)};
`;

/**
 * Ícone
 * Estiliza o ícone associado ao rótulo.
 */
export const Icon = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.mediumBlue};
`;

/**
 * Título
 * Configura o estilo do rótulo associado ao ícone.
 */
export const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.light};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: 1rem;
`;

export const Description = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.light};
  color: ${({ theme }) => theme.colors.placeholderGray};
  font-size: 0.9rem;
  padding-left: 10px;
`;

/**
 * Botão de Controle
 * Estiliza os botões de incremento e decremento com estados dinâmicos.
 */
export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.spacing(3.5)};
  height: ${({ theme }) => theme.spacing(3.5)};
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.lightGray : theme.colors.vividBlue};
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.placeholderGray : theme.colors.black};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.lightGray : theme.colors.darkBlue};
  }
`;

/**
 * Quantidade
 * Exibe o valor atual do seletor com estilo destacado.
 */
export const Quantity = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1rem;
`;
